import { PaymentSource as PaymentSourceApi } from '@vendasta/billing';

export enum PaymentSource {
  UNSET = 'Unset',
  STRIPE = 'Stripe',
  VCASH = 'vCash',
}

export function paymentSourceFromApi(pApi: PaymentSourceApi | undefined): PaymentSource {
  switch (pApi) {
    case PaymentSourceApi.PAYMENT_SOURCE_STRIPE:
      return PaymentSource.STRIPE;
    case PaymentSourceApi.PAYMENT_SOURCE_VCASH:
      return PaymentSource.VCASH;
    default:
      return PaymentSource.UNSET;
  }
}
